/**
 * ============================================================================
 * CharLimitToggle Component
 *
 * 글자 제한 토글 (500자 / 1,000자)
 *
 * 기능:
 * - 세그먼트 컨트롤 UI
 * - Store와 연동된 상태 관리
 * ============================================================================
 */

import { useAppStore, useCharLimit } from '@/stores'
import styles from './CharLimitToggle.module.css'

// ============================================================================
// CharLimitToggle 컴포넌트
// ============================================================================
export function CharLimitToggle() {
  const charLimit = useCharLimit()
  const setCharLimit = useAppStore((state) => state.setCharLimit)

  const handleLimitChange = (limit: 500 | 1000) => {
    setCharLimit(limit)
  }

  return (
    <div className={styles.charLimitToolbar}>
      <span className={styles.charLimitLabel}>글자 제한:</span>
      <div className={styles.segmentedControl} role="tablist" aria-label="글자 제한 선택">
        <button
          type="button"
          className={`${styles.segmentBtn} ${charLimit === 500 ? styles.active : ''}`}
          onClick={() => handleLimitChange(500)}
          role="tab"
          aria-selected={charLimit === 500}
        >
          500자
        </button>
        <button
          type="button"
          className={`${styles.segmentBtn} ${charLimit === 1000 ? styles.active : ''}`}
          onClick={() => handleLimitChange(1000)}
          role="tab"
          aria-selected={charLimit === 1000}
        >
          1,000자
        </button>
      </div>
    </div>
  )
}

export default CharLimitToggle
